/**
 * MCP OAuth consent flow console tracing (always on in Vite dev).
 * Production: enable with localStorage.setItem("integratorDebugMcpOAuth", "1").
 */
import { appendAuthTrace } from "./auth-trace";

const KEY = "integratorDebugMcpOAuth";

function enabled(): boolean {
  if (import.meta.env.DEV) return true;
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

function redactPayload(payload: Record<string, unknown>): Record<string, unknown> {
  const safe = { ...payload };
  for (const k of Object.keys(safe)) {
    if (/token|secret|password|code_challenge|authorization/i.test(k) && typeof safe[k] === "string") {
      const value = safe[k] as string;
      safe[k] = value.length > 0 ? `(${value.length} chars, redacted)` : "";
    }
  }
  return safe;
}

export function mcpOAuthLog(phase: string, payload: Record<string, unknown> = {}): void {
  if (!enabled()) return;
  const safe = redactPayload(payload);
  let line: string;
  try {
    line = `[integrator:mcp-oauth] ${phase} ${JSON.stringify(safe)}`;
  } catch {
    line = `[integrator:mcp-oauth] ${phase} (payload not serializable)`;
  }
  console.info(line);
  appendAuthTrace(`mcp-oauth:${phase}`, safe);
}
